import React from 'react';

// Covers both monitoring domains: server health (healthy/unhealthy/unknown),
// app availability (available/unavailable/unknown) and proxy provisioning
// state (created/creating/error).
const COLOR_MAP = {
  healthy:     { bg: 'bg-success-bg', text: 'text-success-ink', dot: 'bg-success-alt', label: 'healthy' },
  available:   { bg: 'bg-success-bg', text: 'text-success-ink', dot: 'bg-success-alt', label: 'available' },
  created:     { bg: 'bg-success-bg', text: 'text-success-ink', dot: 'bg-success-alt', label: 'created' },
  active:      { bg: 'bg-success-bg', text: 'text-success-ink', dot: 'bg-success-alt', label: 'active' },
  unhealthy:   { bg: 'bg-danger-bg',     text: 'text-danger-ink',     dot: 'bg-danger',     label: 'unhealthy' },
  unavailable: { bg: 'bg-danger-bg',     text: 'text-danger-ink',     dot: 'bg-danger',     label: 'unavailable' },
  error:       { bg: 'bg-danger-bg',     text: 'text-danger-ink',     dot: 'bg-danger',     label: 'error' },
  faulty:      { bg: 'bg-danger-bg',     text: 'text-danger-ink',     dot: 'bg-danger',     label: 'faulty' },
  creating:    { bg: 'bg-warning-bg',   text: 'text-warning-ink',   dot: 'bg-warning',   label: 'creating' },
  unknown:     { bg: 'bg-fill',   text: 'text-ink-muted',    dot: 'bg-ink-muted',    label: 'unknown' },
};

const StatusBadge = ({ status, label, spinning, className = '' }) => {
  const cfg = COLOR_MAP[status] || COLOR_MAP.unknown;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${cfg.bg} ${cfg.text} ${className}`}
    >
      {spinning ? (
        <span className={`w-2 h-2 rounded-full border-2 border-current border-t-transparent animate-spin shrink-0`} />
      ) : (
        <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${cfg.dot}`} />
      )}
      {label || cfg.label}
    </span>
  );
};

export default StatusBadge;
